import * as authSelectors from "@rentiohq/shared-frontend/dist/redux/auth/auth.selectors";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { IRootState } from "../redux/reducers";

const withAuthenticationCheck = (Component: any) => {
  const WithAuthenticationCheck = (props: any) => {
    const hasAccessToken = useSelector((state: IRootState) =>
      authSelectors.hasAccessToken(state),
    );
    const user = useSelector((state: IRootState) =>
      authSelectors.getUser(state),
    );

    const renderRedirect = (pathname: string) => (
      <Navigate
        to={{
          pathname,
        }}
        state={{
          referrer: `${window.location.pathname}${window.location.search}`,
        }}
      />
    );

    // Render
    if (user?.unverifiedPhone) {
      return renderRedirect("/auth/verify/phone");
    }

    if (user?.unverifiedEmail) {
      return renderRedirect("/auth/verify/email");
    }

    if (!hasAccessToken || !user) {
      return renderRedirect("/auth/signin");
    }

    return <Component {...props} />;
  };

  return WithAuthenticationCheck;
};

export default withAuthenticationCheck;
